// extracted by mini-css-extract-plugin
export default {"container":"dialog_container__2Mi30"};